import React from 'react';
import ShoppingMenuTab from '@/components/shoppings/ShoppingMenuTab';
import useShoppingList from '@/hooks/useShoppingList';

const SHOPPING_CATEGORY_1 = 'テーブルウェア';
const SHOPPING_CATEGORY_2 = '調理器具';
const SHOPPING_CATEGORY_3 = 'インテリア';
const SHOPPING_CATEGORY_4 = '整理整頓';
const SHOPPING_CATEGORY_5 = 'リラックス';
const SHOPPING_CATEGORY_6 = 'ファッション';

const ShoppingMenuTabContainer: React.FC = () => {
  const shoppingList = useShoppingList();
  const shoppingClassList = [
    SHOPPING_CATEGORY_1,
    SHOPPING_CATEGORY_2,
    SHOPPING_CATEGORY_3,
    SHOPPING_CATEGORY_4,
    SHOPPING_CATEGORY_5,
    SHOPPING_CATEGORY_6
  ];
  return <ShoppingMenuTab shoppingList={shoppingList} categoryList={shoppingClassList} />;
};

export default ShoppingMenuTabContainer;
